module.exports = __webpack_public_path__ + "img/car-side-bolt.b111eda3.svg";